import React, { useContext } from 'react'
import { LinkGetProps } from '@reach/router'
import { Link } from 'gatsby'

type NavigationContextType = {
  onNavigationChange: (route: string) => void
}

export const NavigationContext = React.createContext<NavigationContextType>({
  onNavigationChange: () => console.warn('No matching context provider found'),
})

type LinkProps = {
  to: string
  className?: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getProps?: (props: LinkGetProps) => Record<string, any>
}

export const isExternalLink = (link: string) => /^https?:\/\/.+|\/dashboard|\/faq/.test(link)

export const ContextLink: React.FC<LinkProps> = ({ children, to, className, getProps }) => {
  const { onNavigationChange } = useContext(NavigationContext)

  // Use Gatsby Router Link for internal links, and <a> for others
  if (isExternalLink(to)) {
    return (
      <a href={to} className={className}>
        {children}
      </a>
    )
  }

  return (
    <Link to={to} className={className} getProps={getProps} onClick={() => onNavigationChange(to)}>
      {children}
    </Link>
  )
}
